import { HIDE_TOOLTIP } from '../../reducer';

export const PROCESSING_VOLUME_TOOLTIP =
  'Dashboard/Referrals/PROCESSING_VOLUME_TOOLTIP';
export const TRANSACTION_FEES_TOOLTIP =
  'Dashboard/Referrals/TRANSACTION_FEES_TOOLTIP';
export const SET_SHOW_ID = 'Dashboard/Referrals/SET_SHOW_ID';
export const REMOVE_SHOW_ID = 'Dashboard/Referrals/REMOVE_SHOW_ID';
export const SET_ACTIVE_SECTION = 'Dashboard/Referrals/SET_ACTIVE_SECTION';
export const RESET_REFERRALS_STATE =
  'Dashboard/Referrals/RESET_REFERRALS_STATE';
export const SHOW_TOOLTIP = 'Dashboard/Referrals/SHOW_TOOLTIP';

export const PARTNERS = 'PARTNERS';
export const MERCHANTS = 'MERCHANTS';

export const setShowId = showId => ({
  type: SET_SHOW_ID,
  showId
});

export const removeShowId = () => ({
  type: REMOVE_SHOW_ID
});

export const setActiveSection = activeSection => ({
  type: SET_ACTIVE_SECTION,
  activeSection
});

export const resetReferralsState = () => ({
  type: RESET_REFERRALS_STATE
});

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

const initialState = {
  activeSection: MERCHANTS
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_SHOW_ID:
      return {
        ...state,
        showId: null
      };
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.activeSection,
        showId: null
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: null
      };
    case SET_SHOW_ID:
      return {
        ...state,
        showId: action.showId
      };
    case RESET_REFERRALS_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
